import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Col, Row } from "antd";
import titleize from "underscore.string/titleize";
//actions
import { actions } from "actions/resources";

export class ChallengeDetail extends Component {
  componentWillMount() {
    this._fetchDependencies();
  }

  _fetchDependencies = async () => {
    const { fetchChallenge, fetchCompany, match } = this.props;
    const challenge = await fetchChallenge(match.params.id);
    fetchCompany(challenge.payload.company_id);
  };

  render() {
    const { challenge, company } = this.props;
    const colors = { active: "#64b10a", created: "#64b10a" };
    if (challenge && company) {
      return (
        <div className="detail-spacer">
          <Row type="flex" align="middle">
            <Col span={18}>
              <h1 id="header">{challenge.name || "No challenge name"}</h1>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <span className="bold">Status: </span>
              <span style={{ color: colors[challenge.status] }}>
                {titleize(challenge.status)}
              </span>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit">
                Edit Challenge
              </Button>
            </Col>
          </Row>
          <Row
            type="flex"
            justify="space-between"
            align="top"
            style={{ marginTop: 40 }}
          >
            <Col>
              <Row>
                <Col>
                  <span className="bold">Company</span>
                </Col>
              </Row>
              <Row>
                <Col>{company.name}</Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col>
                  <span className="bold">Project type</span>
                </Col>
              </Row>
              <Row>
                <Col>N/A</Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col>
                  <span className="bold">Start Date</span>
                </Col>
              </Row>
              <Row>
                <Col>N/A</Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col>
                  <span className="bold">End Date</span>
                </Col>
              </Row>
              <Row>
                <Col>N/A</Col>
              </Row>
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  }
}

export default connect(
  state => ({
    challenge: state.resources.detail.challenge,
    company: state.resources.detail.company
  }),
  dispatch => ({
    fetchChallenge: bindActionCreators(actions.fetchChallenge, dispatch),
    fetchCompany: bindActionCreators(actions.fetchCompany, dispatch)
  })
)(ChallengeDetail);



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/detail.js